import React from "react";
import { Link } from "react-router-dom";
import '../styles/Footer.css';
import { FaInstagram, FaTelegramPlane, FaEnvelope } from "react-icons/fa";
import { SiVisa, SiMastercard, SiEthereum } from "react-icons/si";
import { GiCardAceSpades } from "react-icons/gi";
import { useTranslation } from "react-i18next";
import { useGeo } from "../context/GeoContext";
import { useAuth } from "../context/AuthContext";
import { usePayment } from "../context/PaymentContext";
import { useNavigate } from "react-router-dom";

const languageOptions = [
  { code: "ru", label: "Русский" },
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "am", label: "Armenian" },
  { code: "be", label: "Беларускі" },
  { code: "tr", label: "Türkçe" },
  { code: "kz", label: "Kазақша" },
  { code: "az", label: "Azərbaycan" }
];

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { openGlobalLangDropdown } = useGeo();
  const { isAuth } = useAuth();
  const { openPaymentModal } = usePayment();
  const navigate = useNavigate();

  const handlePayIconClick = () => {
    if (!isAuth) {
      try {
        const event = new CustomEvent('open-auth-modal', { detail: { mode: 'register' } });
        window.dispatchEvent(event);
      } catch {}
      return;
    }
    openPaymentModal({ type: 'deposit' });
  };

  const getFlagFile = (lang) => {
    switch (lang) {
      case "ru": return "/flags/ru.svg";
      case "en": return "/flags/en.svg";
      case "pt": return "/flags/pt.svg";
      case "am": return "/flags/am.svg";
      case "be": return "/flags/be.svg";
      case "az": return "/flags/az.svg";
      case "tr": return "/flags/tr.svg";
      case "id": return "/flags/id.svg";
      case "kz": return "/flags/kz.svg";
      default: return "/flags/en.svg";
    }
  };

  return (
    <footer className="footer-modern">
      <div className="footer-modern__container">
        {/* Верхний блок: меню и поддержка */}
        <div className="footer-modern__main">
          <div className="footer-modern__logo-col">
            <img src="../assets/headerlogo.webp" alt="Oncaspin Casino" className="footer-modern__logo" />
          </div>
          <div className="footer-modern__links">
            <div className="footer-modern__section">
              <div className="footer-modern__section-title">{t('footer.casinoSection')}</div>
              <ul>
                <li><Link to="/" className="footer-modern__link">{t('footer.games')}</Link></li>
                <li><Link to="/freemoney" className="footer-modern__link">{t('footer.freebies')}</Link></li>
                <li><Link to="/bonuses" className="footer-modern__link">{t('footer.bonuses')}</Link></li>
              </ul>
            </div>
            <div className="footer-modern__section">
              <div className="footer-modern__section-title">{t('footer.infoTitle')}</div>
              <ul>
                <li><Link to="/terms" className="footer-modern__link">{t('footer.terms')}</Link></li>
                <li><Link to="/referral" className="footer-modern__link">{t('footer.referralProgram')}</Link></li>
                <li><Link to="/bonuses" className="footer-modern__link">{t('footer.bonuses')}</Link></li>
              </ul>
            </div>
            <div className="footer-modern__section">
              <div className="footer-modern__section-title">{t('footer.supportTitle')}</div>
              <ul>
                <li><a href="mailto:admin@oncaspin.com" className="footer-modern__link"><FaEnvelope className="footer-modern__icon" /> admin@oncaspin.com</a></li>
                <li><a href="https://t.me/oncaspins" target="_blank" rel="noopener noreferrer" className="footer-modern__link"><FaTelegramPlane className="footer-modern__icon" /> @oncaspins</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-modern__support-card">
            <div className="footer-modern__support-title">{t('footer.supportTitle')} <span className="footer-modern__support-badge">{t('footer.support24_7')}</span></div>
            <div className="footer-modern__support-text">{t('footer.supportText')}</div>
            <a href="https://t.me/oncaspins" target="_blank" rel="noopener noreferrer" className="footer-modern__support-btn">{t('footer.contactButton')}</a>
            <img src="../assets/banners/supportGirl.webp" alt="Support" className="footer-modern__support-img" />
          </div>
        </div>

        {/* Разделитель */}
        <div className="footer-modern__divider" />

        {/* Платежные системы и языки */}
        <div className="footer-modern__payments-langs">
          <div className="footer-modern__payments">
            {/* Сначала локальные/банковские методы */}
            <span className="footer-modern__payicon" title="СБП" onClick={handlePayIconClick}><img src="/assets/methods/sbp-Symbol.svg" alt="SBP" /></span>
            <span className="footer-modern__payicon" title="МИР" onClick={handlePayIconClick}><img src="/assets/methods/mir.svg" alt="MIR" /></span>
            <span className="footer-modern__payicon" title="Visa" onClick={handlePayIconClick}><img src="/assets/methods/visa.svg" alt="Visa" /></span>
            <span className="footer-modern__payicon" title="Mastercard" onClick={handlePayIconClick}><img src="/assets/methods/mastercard.svg" alt="Mastercard" /></span>
            <span className="footer-modern__payicon" title="QR НСПК" onClick={handlePayIconClick}><img src="/assets/methods/nspk.svg" alt="QR NSPK" /></span>

            {/* Затем популярные криптовалюты */}
            <span className="footer-modern__payicon" title="Bitcoin" onClick={handlePayIconClick}><img src="/assets/crypto/btc.svg" alt="BTC" /></span>
            <span className="footer-modern__payicon" title="USDT" onClick={handlePayIconClick}><img src="/assets/crypto/tether.svg" alt="USDT" /></span>
            <span className="footer-modern__payicon" title="ETH" onClick={handlePayIconClick}><img src="/assets/crypto/eth.svg" alt="ETH" /></span>

            {/* Остальные поддерживаемые криптовалюты */}
            <span className="footer-modern__payicon" title="USDC" onClick={handlePayIconClick}><img src="/assets/crypto/usdc.svg" alt="USDC" /></span>
            <span className="footer-modern__payicon" title="TRX" onClick={handlePayIconClick}><img src="/assets/crypto/tron.svg" alt="TRX" /></span>
            <span className="footer-modern__payicon" title="BNB" onClick={handlePayIconClick}><img src="/assets/crypto/bnb.svg" alt="BNB" /></span>
            <span className="footer-modern__payicon" title="LTC" onClick={handlePayIconClick}><img src="/assets/crypto/litecoin.svg" alt="LTC" /></span>
            <span className="footer-modern__payicon" title="XMR" onClick={handlePayIconClick}><img src="/assets/crypto/monero.svg" alt="XMR" /></span>
            <span className="footer-modern__payicon" title="DOGE" onClick={handlePayIconClick}><img src="/assets/crypto/doge.svg" alt="DOGE" /></span>
            <span className="footer-modern__payicon" title="BCH" onClick={handlePayIconClick}><img src="/assets/crypto/bch.svg" alt="BCH" /></span>
            <span className="footer-modern__payicon" title="DASH" onClick={handlePayIconClick}><img src="/assets/crypto/dash.svg" alt="DASH" /></span>
            <span className="footer-modern__payicon" title="ZEC" onClick={handlePayIconClick}><img src="/assets/crypto/zec.svg" alt="ZEC" /></span>
            <span className="footer-modern__payicon" title="XLM" onClick={handlePayIconClick}><img src="/assets/crypto/stellar.svg" alt="XLM" /></span>
            <span className="footer-modern__payicon" title="Xrp" onClick={handlePayIconClick}><img src="/assets/crypto/xrp.svg" alt="XRP" /></span>
          </div>
          {/* Языки */}
          <div className="footer-modern__langs">
            <button
              className="footer-modern__lang-btn"
              onClick={(e) => openGlobalLangDropdown(e.currentTarget)}
            >
              <img src={getFlagFile(i18n.language)} alt="language" className="footer-modern__lang-flag" />
              <span>{languageOptions.find(l => l.code === i18n.language)?.label || 'Language'}</span>
            </button>
          </div>
        </div>

        {/* Разделитель */}
        <div className="footer-modern__divider" />

        {/* Лицензии и копирайт */}
        <div className="footer-modern__bottom">
          <div className="footer-modern__licenses">
            <a href="https://www.responsiblegambling.org/" target="_blank" rel="noopener noreferrer"><img src="/assets/photo/logo-rgc.svg" alt={t('footer.responsibleGamblingAlt')} className="footer-modern__license-icon" /></a>
            <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer"><img src="/assets/photo/be-gamble-aware.png" alt={t('footer.beGambleAwareAlt')} className="footer-modern__license-icon" /></a>
            <span className="footer-modern__age">{t('footer.18plus')}</span>
          </div>
          <div className="footer-modern__copyright">
            {t('footer.copyright')}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;